import * as React from "react"
// @ts-ignore
import { saDefaultHeaderContainer,saDefaultBlock,saDefaultTitleContainer,saDefaultTitle,saDefaultText,saDefaultImage,saDefaultButton, saBtn } from './saDefaultHeader.module.scss'
import { SaButton } from "../saButton/saButton"
import { SaTitle } from "../saTitle/saTitle"
import SaImage from "../saImage/saImage"
import { saInterfaceDefaultSection } from "../saTypes" 




export const SaDefaultHeader: React.FC<saInterfaceDefaultSection> = ({ ...props }) =>  {


    return (
      <div className={'saContainer ' + saDefaultHeaderContainer}>


        <div className={saDefaultBlock}>

          {
            props.title &&
            <div className={saDefaultTitleContainer}>
              <SaTitle title={props.title} classes={saDefaultTitle}/>
            </div>
          }

          {
            props.text &&
            <div className={saDefaultText}
                 dangerouslySetInnerHTML={{__html: props.text}}/>
          }

          {
            props.button &&
            <div className={saDefaultButton}>
              <SaButton {...props.button} classes={saBtn}/>
            </div>
          }

        </div>

        {
          props.image &&
          <div className={saDefaultImage}>
            <SaImage {...props.image} />
          </div>
        }


      </div>
    )

}
